<template>
    <div>
        <div class="mb-3">
            <a href="back" @click.prevent="goBack" class="link-hover-line text-sm text-default">
                <i class="fa fa-arrow-left mr-1"></i> Go back to search shop
            </a>
        </div>
        <div class="bg-white shadow-reg list-container card-list-container">
            <h6 class="heading-small ml-4 mt--4 text-muted">Available shops</h6>
            <paginated-section class="card-list" :fetch-link="shopFetchLink" :params="fetchParams" paginate-path="data.result.shops" ref="list" simplified @fetch-failed="failedToFetch">
                <template slot="loading">
                    <h3 class="table-placeholder text-muted m-0 pt-5 pb-5 text-center">
                        <i class="fas fa-spin fa-spinner mr-2"></i> Loading shops
                    </h3>
                </template>
                <template slot="empty">
                    <div class="mb-5 text-center">
                        <h3 class="table-placeholder text-muted m-0 pt-5 pb-5">No shops were found</h3>
                        <button class="btn btn-warning" @click="goBack">Go back</button>
                    </div>
                </template>
                <template slot="body" slot-scope="{ record }">
                    <shop-list-item :shop="record" @select="select" />
                </template>
            </paginated-section>
        </div>
    </div>
</template>
<script>
import mixins from "@utils/mixins";
import { route } from '@utils/network';
import ShopListItem from "./ShopListItem";

export default {
    name: "ShopSelectionSection",

    components: { ShopListItem },

    computed: {
        fetchParams() {
            return this.$store.getters.shopSearchParams;
        },
    },

    data: () => ({
        isLoading: false,
        shopFetchLink: route("shops/search"),
    }),
    
    methods: {
        select(shop) {
            this.$store.dispatch("setShop", shop);

            this.$emit("next");
        },
        failedToFetch(error) {
            this.$emit("previous", error);
        },
        goBack() {
            this.$emit("previous");
        },

        handleErrors(error) {
            this.promptErrors(error.response.data.message);
        },
    },

    mixins: [mixins],

}
</script>